import React, {
    useEffect, useState, useRef,
    useMemo,
    useCallback
} from "react"; import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import "./settings.css"
import Table from "../Table";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { useSelector, useDispatch } from "react-redux";
import { setCompanyUserLoading } from "ReduxStore/Slices/companyUserSlice";
import ContactLoader from "views/ContantLoader";
import { Container } from "reactstrap";
import CustomModal from '../../components/customModal/CustomModal'
import { getDeals, addField, getDealsFieldsCount, editFieldApi } from '../../api/SettingsApi'
import { toast } from "react-toastify";

var offSet = 0;
var matchNextButton = 1;

function Deal(props) {

    const [dataApi, setDataApi] = useState([]);
    const [total, setTotal] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [showModal, setShow] = useState(false)

    const [focusedFieldName, setFocusedName] = useState(null);
    const [focusedFieldType, setFocusedType] = useState("number");
    const [editField, setEdit] = useState(null)


    const { companyUserLoading } = useSelector(
        (state) => state.companyUserSetter
    );
    const dispatch = useDispatch();
    useEffect(() => {
        //  dispatch(setCompanyUserLoading(true));
    }, []);
    const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
        //dispatch(setCompanyUserLoading(true));
        const startRow = pageSize * pageIndex;
        const endRow = startRow + pageSize;
        setPageIndex(pageIndex);
        await getDealsFieldsCount()
            .then((data) => {
                setPageCount(Math.ceil(data.count / pageSize));
                setTotal(data.count);
            })
            .catch((e) => { })

        await getDeals(pageSize, startRow)
            .then((data) => {
                data.forEach((r) => {
                    r.dataTypeCap = r.dataType ? capitalize(r.dataType) : ''

                })
                //
                setDataApi(data);
                dispatch(setCompanyUserLoading(false));

            })
            .catch((e) => { })
    }, []);

    function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }


    const data = useMemo(() => dataApi, [dataApi]);
    const columns = useMemo(
        () => [
            {
                Header: "Field Name",
                accessor: "label",

            },
            {
                Header: "Key",
                accessor: "key",

            },
            {
                Header: "Field Type",
                accessor: "dataTypeCap",

            },

            {
                // width: 300,
                Header: "",
                accessor: "ff",
                Cell: ({ cell }) => (


                    (cell.row.original.schemaType == 'custom' ?

                        <div >
                            <OverlayTrigger
                                delay={{ hide: 50, show: 50 }}
                                placement="top"
                                key="top"
                                overlay={(props) => (
                                    <Tooltip id="tooltip-top" {...props}>
                                        Edit Field
                                    </Tooltip>
                                )}
                            >
                                <i
                                    className="fa fa-edit"
                                    style={{ color: "gray", fontSize: "20px" }}
                                    onClick={() => { setEdit(cell.row.original.id); setShow(true); setFocusedType(cell.row.original.dataType); setFocusedName(cell.row.original.label) }}
                                ></i>
                            </OverlayTrigger>
                            <OverlayTrigger
                                delay={{ hide: 50, show: 50 }}
                                placement="top"
                                key="top"
                                overlay={(props) => (
                                    <Tooltip id="tooltip-top" {...props}>
                                        Delete Field
                                    </Tooltip>
                                )}
                            >
                                <i
                                    className="fa fa-trash"
                                    style={{ color: "gray", fontSize: "20px", marginLeft: "40px" }}
                                    onClick={() => handleDel(cell.row.original.id, cell.row.original.label)}
                                ></i>
                            </OverlayTrigger>
                        </div>
                        : <span></span>
                    )
                ),
            },
        ],
        [dataApi]
    );
    const handleDel = (id, label) => {
        if (window.confirm('Are you sure you want to delete this attribute?')) {
            // Save it!
            editFieldApi(id, { isDeleted: true, label: label })
                .then((data) => {
                    let d = [...dataApi];
                    d = d.filter(r => r.id != id)
                    setDataApi(d)
                    setShow(false)
                    toast.success("Field has been deleted successfully");

                })
        }

    }
    const handleSave = () => {
        if (editField) {

            let body = {
                label: focusedFieldName,
                dataType: focusedFieldType

            }

            editFieldApi(editField, body)
                .then((data) => {
                    let d = [...dataApi];
                    d = d.map((r) => {
                        if (r.id == data.id) {
                            r.label = body.label
                            r.dataType = body.dataType
                        }
                        return r
                    });
                    // setDataApi(d)
                    fetchData({ pageSize: 50, pageIndex: 0 })
                    setShow(false)
                    toast.success("Field has been Saved successfully");

                })
            return
        }

        let body = {
            label: focusedFieldName,
            dataType: focusedFieldType

        }
        addField(body)
            .then((data) => {
                let d = [...dataApi];
                d.push(body);
                fetchData({ pageSize: 50, pageIndex: 0 })
                setShow(false)
                toast.success("Field has been deleted successfully");

            })
    }
    const handleClose = () => {
        setShow(false);
    }

    return (
        <div className='deal'>
            <div style={{ padding: '20px' }}>
                <p className="sm d-flex align-items-center">
                    You have {total} Deal Fields.
                </p></div>
            <div className='deal_head' >
                <input
                    type="submit"
                    name="Save"
                    style={{ margin_top: "2v", cursor: "pointer" }}
                    className="add lg_btn primary"
                    value="Add Field"
                    onClick={() => { setEdit(null); setFocusedName(null); setShow(true) }}
                />
            </div>
            <Table
                columns={columns}
                data={data}
                pageCount={pageCount}
                fetchData={fetchData}
                loading={companyUserLoading}
            ></Table>

            {showModal ?
                <CustomModal title="Add a Field"
                    show={showModal}
                    handleClose={handleClose}
                    handleSave={handleSave}
                    body={<div style={{
                        padding: '20px 40px',
                        width: '100%'
                    }}>
                        <h6 style={{ fontSize: '17px', marginLeft: '10px', }}>Field Name</h6>
                        <input
                            style={{
                                width: '80%',
                                padding: '7px',
                                margin: '10px',
                                outline: '2px'
                            }}
                            placeholder='Type Name'
                            value={focusedFieldName}
                            onChange={(e) => setFocusedName(e.target.value)}

                        ></input>
                        <h6 className='mt-4' style={{ fontSize: '17px', marginLeft: '10px', }}>Field Type</h6>
                        <select
                            style={{
                                width: '80%',
                                padding: '7px',
                                margin: '10px',
                                outline: '2px'
                            }}
                            placeholder='Type Name'
                            value={focusedFieldType}
                            disabled={editField ? true : false}
                            onChange={(e) => setFocusedType(e.target.value)}

                        >
                            <option value="number">Number</option>
                            <option value="text">Text</option>
                            <option value="dateTime">DateTime</option>
                            <option value="boolean">Boolean</option>
                            <option value="string">String</option>
                            <option value="date">Date</option>


                        </select>

                    </div>
                    }

                />
                : null}
        </div>
    );
}
export default Deal;
